export default function addThousandSeperator(number: number): string {
	const afterComma = number.toFixed(2).replace('.', ',').slice(-3);
	return (
		number
			.toString()
			.split('.')[0]
			.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + afterComma
	);
}
